import { useState, useMemo } from 'react';
import { IArticleItem, SortOrder } from '../interfaces/types';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import 'dayjs/locale/en';

dayjs.extend(isBetween);

interface IAppliedFilter {
    filterName: string;
    filterValue: string;
}

export function useArticleFilters(articles: IArticleItem[], itemsPerPage: number) {
    const [appliedFilterCategories, setAppliedFilterCategories] = useState<IAppliedFilter[]>([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [appliedSortOrder, setAppliedSortOrder] = useState('newest');
    // Filtered articles are derived from state
    const filteredArticles = useMemo(() => {
        let newFilteredArticles = articles.filter(article => {
            const matchesCategory = appliedFilterCategories.length === 0 ||
                appliedFilterCategories.every(category => article.categories.includes(category.filterValue));
            return matchesCategory;
        });
        if (appliedSortOrder === SortOrder.Newest) {
            newFilteredArticles = newFilteredArticles.sort((a, b) => dayjs(b.publishDate).diff(dayjs(a.publishDate)))
        }
        else {
            newFilteredArticles = newFilteredArticles.sort((a, b) => dayjs(a.publishDate).diff(dayjs(b.publishDate)))
        }
        return newFilteredArticles;
    }, [articles, appliedFilterCategories, appliedSortOrder]);

    // Pagination
    const pageCount = Math.ceil(filteredArticles.length / itemsPerPage);
    const pagedArticles = useMemo(() => {
        const start = currentPage * itemsPerPage;
        return filteredArticles.slice(start, start + itemsPerPage);
    }, [filteredArticles, currentPage, itemsPerPage]);

    // Toggle category helper
    const toggleCategory = (label: string, category: string) => {
        let currentAppliedFilterCategories = [...appliedFilterCategories];
        let categoryIsSelected = currentAppliedFilterCategories.filter(filterItem => filterItem.filterName === label).length > 0;
        if (categoryIsSelected || category === "") {//Remove it
            currentAppliedFilterCategories = currentAppliedFilterCategories.filter(filterItem => filterItem.filterName !== label)
        }
        if (category === "") {
            setAppliedFilterCategories([...currentAppliedFilterCategories]);
        }
        else {
            setAppliedFilterCategories([...currentAppliedFilterCategories, {
                filterName: label,
                filterValue: category
            }]);
        }
        //setAppliedFilterCategories(prev =>
        //    isChecked ? [...prev, category] : prev.filter(c => c !== category)
        //);
        setCurrentPage(0); // Reset pagination when filters change
    };

    const updateSortOrder = (sortOrder: string) => {
        setAppliedSortOrder(sortOrder);
    }

    // Reset all filters
    const resetFilters = () => {
        setAppliedSortOrder('newest')
        setAppliedFilterCategories([]);
        setCurrentPage(0);
    };

    return {
        appliedFilterCategories,
        filteredArticles,
        pagedArticles,
        currentPage,
        pageCount,
        setCurrentPage,
        toggleCategory,
        resetFilters,
        appliedSortOrder,
        updateSortOrder,
    };
}
